import { TemplateItem } from './StoresFunnelChooseTemplate.data'

const FASHION_APPAREL: TemplateItem[] = [
  {
    templateId: 'd74e8fd5-924e-47f7-ab48-e81dc41e1761',
    title: 'T- Shirt Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/9223efcf6c6676c63920198693847a599dd4d3d758d72bd66454f4bc22f0fc791625750138735.jpg',
  },
  {
    templateId: 'e51d7741-76c0-4f61-a133-f7af421c3846',
    title: 'Clothing Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/2197570a3dc2cd995db89c39bdb8828f2eb47664eac81aa29477cd6ebde8eb781703407175443.jpg',
  },
  {
    templateId: '4fcd770d-ab1c-4530-ada2-1920b43d7925',
    title: 'Fashion Clothing Store ',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/7bc159c2032cb2dd4056edfa210fe15ed0fb1517f91b0269b2ae0bff1d2679f31594561698793.jpg',
  },
  {
    templateId: 'bdb4e3ef-cb90-4d10-9a09-65893e11dc0c',
    title: 'Clothing Store (MODA)',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/4b0b2eb5fa3ad03e38e8c242a741aad40db237e60de6650ef8832c3ce01b8c1d1641818317979.jpg',
  },
  {
    templateId: '46357a83-405f-48cf-9a2f-edbfcaf55a86',
    title: 'Clothing Boutique (Chic)',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/0e2cc157c66761fa01fa9e285a68906bb6f339f26200315701d3f4b3096fe4041744701718879.jpg',
  },
  {
    templateId: '5376b748-c9c2-4be5-bc6b-dc89c309d23c',
    title: 'Women Shoe Shop (Trendy)',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/97e7bd06970661a63ec39f4d35eefacacddd06c31a58c5dd48d0821a8fea4d621744109447368.jpg',
  },
]

const BEAUTY_AND_HAIR: TemplateItem[] = [
  {
    templateId: 'e5270f42-25b8-4f7a-aafb-2e609a06e17f',
    title: 'Home Goods Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/9acbc2ef7ac23f6554d26f2166d64fba6114a32692b8640009e32598e63c06041675844789411.jpg',
  },
  {
    templateId: '823f5332-5b27-42be-bf35-48c75e5ed908',
    title: 'Spa',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/f588a9bc416eda659bf84130f57153dac8dc7f818b6b1ae7319bb2ea26f9180a1635254042804.jpg',
  },
  {
    templateId: '57911fa8-a432-45c0-b84f-67f718513b29',
    title: 'Beauty Shop',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/0f1759341470b841142b6fad0e8c23a25c92efe544ebcbab50747735d12068121622376102757.jpg',
  },
  {
    templateId: '5a0ef9eb-8698-46c6-80a0-ff9d86812d92',
    title: 'Hair Extension & Lash Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/38b658a4e69ae7926ba3d9cf37ac38538bb7b182f1df0221438a7891007c9be11731416927442.jpg',
  },
  {
    templateId: '32247b67-b460-4f6e-aa4e-47c0f212929d',
    title: 'Essential Oils Store (Organic)',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/1e0b9382a171c8215db112dbbac311ed4f015fac8e7e64313af17ea12ba704de1744702111980.jpg',
  },
  {
    templateId: '508da751-8164-419d-8ba5-1888abd85532',
    title: 'Online Bath & Body Products Store (Elegant)',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/99ce0c076e848694f6dec3f9005c59ef4dfa40d2f61f73dcae1eeb9b43e5f92c1745312763232.jpg',
  },
]

const HOME_LIVING: TemplateItem[] = [
  {
    templateId: 'e5270f42-25b8-4f7a-aafb-2e609a06e17f',
    title: 'Home Goods Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/9acbc2ef7ac23f6554d26f2166d64fba6114a32692b8640009e32598e63c06041675844789411.jpg',
  },
  {
    templateId: '3a5ca34d-a5d5-4635-8856-9634def8684e',
    title: 'Gift Shop',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/66b30d99ae1522c989f65c98c91b070f1fea67e83f63b78517d4f13c5e3671f41702801949529.jpg',
  },
  {
    templateId: '45779429-948f-4e77-a8b4-2f2883145e3c',
    title: 'Ceramic Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/e17eba8f82f2ea764faeb2d88bc04f3d59bdde687d0ad8a6178afa1fafecf85c1703414203860.jpg',
  },
  {
    templateId: '7e0d4f62-cac0-41d7-80fe-1a5a1cb8d4d8',
    title: 'Plant Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/201c663c3d1dda557cb33eb32ea0c68ccf28bb5e4486565c39bd0c7ef0d50ed81631513480147.jpg',
  },
  {
    templateId: 'f2815e67-5fb9-4dee-a07f-cbbc18c419f5',
    title: 'Ecom Natural Candle Boutique',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/3f56a4d2fd3f2f425fc4842a9b0d2f4c29ef28043c6978253439b75db2a38e5b1744702105720.jpg',
  },
  {
    templateId: '688224c2-51bd-4248-8871-e3dfbd9237c4',
    title: 'Online Furniture Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/6c6bd353d2e14d01e36e82145c59ef396e901dd6f9fac1ebdea3ad510387a9041748953486409.jpg',
  },
]

const ELECTRONICS_GADGETS: TemplateItem[] = [
  {
    templateId: 'b13ae6bf-ed09-484d-a708-707c0bd807e7',
    title: 'Electronics Store ',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/393c65e591c8198f94527ce3bdf871d399c3ee0cd39dfbc85d2eaafd73c1ba301616683268864.jpg',
  },
  {
    templateId: '186a4581-0aef-4fb0-8ee9-5b400d452ff9',
    title: 'Product Landing Page',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/f17e913b8d139cf584b915c6a23d94fc37f3c4cff3f494121a1925f8f03e014a1631446833929.jpg',
  },
  {
    templateId: '82a35a58-5cde-44f4-8f4b-859c043a52e3',
    title: 'Gaming Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/29a8dcae9a4081f3f6b0566f540f80cf240221664aee2e5cdcbd481a33eea0a41641744500497.jpg',
  },
  {
    templateId: '20367593-361b-40e5-8128-b6dc9114adf6',
    title: 'Product Landing Page (SOUNDBEAM)',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/b4042bf77e9e3e0bcf769eabe99d84b627e011322d6ce776ac368f4e5e43a6ca1627993958934.jpg',
  },
  {
    templateId: 'b0ee2dd4-d99b-42b4-a04e-d3a80588ed27',
    title: 'Electronics Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/9a8efc54cf70e698ef94b17b9267af715e7381ca33af275128c4099f0ffdab2c1731416469249.jpg',
  },
  {
    templateId: '0e1b8493-bd73-4d97-8b82-d01992e4e5c7',
    title: 'Cell Phone Accessories Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/f1b11b0b109fef94a099d05b43939be5de6844e7f7b9ccd13aa25b373d1c6eb3.jpg',
  },
]

const SPORTS_OUTDOORS: TemplateItem[] = [
  {
    templateId: 'e63c8261-1beb-4131-a5f2-b64222d95690',
    title: 'Backpack Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/f436775688f8879ac04fe6761176942643c83aa3fb6dc776d87de8f0b1a82ec71676468850599.jpg',
  },
  {
    templateId: '287f80ad-c14a-48d9-95b7-7ee8098b6cef',
    title: 'Sporting Goods Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/d851eff48f847c129dcaf3d477f54b0ca708c905cbdea68846cb9a04246e153c1731416984621.jpg',
  },
  {
    templateId: '531f03c3-3221-4c34-aeb7-61450b2d4b7d',
    title: 'Sport Merchandise Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/4dc566ffd8844fbe9fa6236df433cbbe9ced2624dc6f7bc3914964ce8d7a7a311664796537747.jpg',
  },
  {
    templateId: 'a7d396b7-c546-46e3-b54c-f9f4736e9b31',
    title: 'Sporting Goods Store ',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/2d39083e1ec2d7ea45d956e110cf7c9ec0cf06c207a991633817441b81fe11501585229337608.jpg',
  },
  {
    templateId: '4659ff9c-a796-4333-b64a-b9fa25f616ee',
    title: 'Golf Shop (Green)',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/46671746d63e1435bfb26e20c1c03357272c7033d807722b3c4229cf2a03a1671748347847749.jpg',
  },
  {
    templateId: '54f377f6-9f9a-4136-bd98-7a3939707d13',
    title: 'Online Sporting Goods Store (Outline)',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/5987400bbc0d0e94001d2088eb7a4688376affde41085a2d668410b6a9795a421750147943469.jpg',
  },
]

const FOOD_BEVERAGES: TemplateItem[] = [
  {
    templateId: '188f4e86-deb6-4fc6-9aa9-e79f1c921277',
    title: 'Supermarket',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/9586f969ed3b6f817d96c7bfc1c8cde2b9f98705cb11a461110fd2327bd6a14d1628751265412.jpg',
  },
  {
    templateId: 'e66ed1bc-a3db-4b18-907a-f106278f0edd',
    title: 'Juice Shop',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/f74bf0de71d2808d76b724b9587904f29f793113e44d80bcd9d31f288bd4f6601645012953808.jpg',
  },
  {
    templateId: '2a6c805b-c189-4972-a03c-274f1ce01675',
    title: 'Coffee Shop',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/8d99e0faaa29385570158a0ab4a54e4b34a92353fb4a947874cffc5516a21fdb1702478138312.jpg',
  },
  {
    templateId: 'c0b3c925-0f8b-4359-bf71-9bc6ceea1beb',
    title: 'Cupcake Pop-Up Shop',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/5667befc6cd8bf18230d9d8223056323935488d2c3cf00412336659d29dfda821742911667290.jpg',
  },
  {
    templateId: '5f907a4f-b7d9-4c54-b3f9-db445d3de8df',
    title: 'Coffee Manufacturer',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/47d64f621765fc5d14d937f6d10637fa00f738989b368f4cd0277a0c970c9e4f1744701662013.jpg',
  },
  {
    templateId: '41ac5804-80c3-425a-8080-2194184891d2',
    title: 'Farm',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/0d590657e57501b9fe25cfd288cad5214285a14eea351efe7537d28492b23565.jpg',
  },
]

const TOYS_KIDS_BABY: TemplateItem[] = [
  {
    templateId: '64fafbac-3afe-4c12-b52f-4aa39dfe2b2d',
    title: 'Toy Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/67c55bec9092e94972b73c0c9194e5ddb6ade34b2bcbfa2d12f5268855806cd9.jpg',
  },
  {
    templateId: 'bc5e01d3-6e5f-426f-bfc3-ca558d22572e',
    title: 'Kids Clothing Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/c31f352d2148eaab99c33453a6d5b29b3b1e297067e2f0b824335d28fbe7949c1703407548761.jpg',
  },
  {
    templateId: '472919c9-149e-431f-a32f-ad234d110c18',
    title: 'Baby Gift Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/706bed462b9603e93b119e719f9dcd6a646198a60a90fc332f9c94e606bd4f151703442057433.jpg',
  },
  {
    templateId: '5a57faf7-6941-4541-9440-e3e0d596cb2a',
    title: 'Kids Clothing Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/a3995937e8ec03d2358de197b33c89113333546fd0ed2014e16be9b52053528d1729431263276.jpg',
  },
  {
    templateId: 'b9d65a21-bd2d-4844-807b-ea03cd752c36',
    title: 'Baby Clothing Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/3bba75ca145558d26b3870f77e1fa1b8543abfea831e3122dd8bce628ba447e51744112266757.jpg',
  },
  {
    templateId: '6a154146-8d5f-43a6-8728-7f6aa64a1c8e',
    title: 'Online Kids Apparel Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/d4621e8ed3c2c2f77b0f52dbf091ad46a318dbf36eac573602851fb0a18437c71748953986657.jpg',
  },
]

const BOOKS_MEDIA_ART: TemplateItem[] = [
  {
    templateId: '879cb9a2-9233-42e4-b5ae-98db04fb4771',
    title: 'Bestselling Author Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/2700e993c897c4e9551a16ccdddadce56ecb806071fc703b42549eb26843f8511745312781717.jpg',
  },
  {
    templateId: '8cb1beb4-a278-4226-8801-94f2a9def745',
    title: 'Writer',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/9fa3a0988da1abe81d6491fa559e4e460ad5adadd20f48b6112dc05e542b7dfe.jpg',
  },
  {
    templateId: '576324f8-b3c2-44fe-9ea7-c22f8375e9c9',
    title: 'eBook Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/7e191b4ad18d592b4b15fa173b073f563fb085a7f3c2e1d994ccfda1f9456c951745312344157.jpg',
  },
  {
    templateId: 'b39fed39-bb59-45a4-9e81-d406f1fd3bd5',
    title: 'Secondhand Book Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/bf2bf5d1cca7206e7306a096146a619730e337de27a2bcfbd2f944d73f38c4071748954395081.jpg',
  },
  {
    templateId: 'da4964fb-4543-4305-8b93-f182fbf1ea14',
    title: 'Children Bookstore',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/01c31a7d7624e7bb55054d3e36869a5bd527c64e65fa6a6363c5a87aabbbafcc1744106848061.jpg',
  },
  {
    templateId: '00e2a511-8706-4d81-8dac-2fc2efcb2684',
    title: 'Rare Bookstore',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/d53ec5c721b7e6698609e1216e9b376d2ae49a345e430553c98f2877de3f9f3a1751351162586.jpg',
  },
]

const SOMETHING_ELSE: TemplateItem[] = [
  {
    templateId: 'e5270f42-25b8-4f7a-aafb-2e609a06e17f',
    title: 'Home Goods Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/9acbc2ef7ac23f6554d26f2166d64fba6114a32692b8640009e32598e63c06041675844789411.jpg',
  },
  {
    templateId: 'd74e8fd5-924e-47f7-ab48-e81dc41e1761',
    title: 'T- Shirt Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/9223efcf6c6676c63920198693847a599dd4d3d758d72bd66454f4bc22f0fc791625750138735.jpg',
  },
  {
    templateId: 'f9bf8eee-6569-46fa-b4e8-e6b8ca8990c1',
    title: 'Accessories Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/ea047bc3ed1a2bc5011edd2bd2640b44c377e7041e9ca93b8a8e5a7686f79d0a1703406661568.jpg',
  },
  {
    templateId: 'ca11886c-1135-4156-b799-ca8b8b7442b9',
    title: 'Accessories Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/2db504a1897c09e85c3b5da8f294fa9ec39d773ae7c497780bb9615617fdcd521703406764698.jpg',
  },
  {
    templateId: 'e63c8261-1beb-4131-a5f2-b64222d95690',
    title: 'Backpack Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/f436775688f8879ac04fe6761176942643c83aa3fb6dc776d87de8f0b1a82ec71676468850599.jpg',
  },
  {
    templateId: 'e523a71a-72d0-4cf2-94ce-e43e7ee5815e',
    title: 'Stationery Store',
    imageUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/4fa7962a1b75c3d97d29532fa8e2c0e4e65b09abaa95ee010d4b02f8501b091c1638778289468.jpg',
  },
]

// Mocked templates data per category
export const templatesMap: Record<string, TemplateItem[]> = {
  fashion_apparel: FASHION_APPAREL,
  beauty_personal_care: BEAUTY_AND_HAIR,
  home_living: HOME_LIVING,
  electronics_gadgets: ELECTRONICS_GADGETS,
  sports_outdoors: SPORTS_OUTDOORS,
  food_beverages: FOOD_BEVERAGES,
  toys_kids_baby: TOYS_KIDS_BABY,
  books_media_art: BOOKS_MEDIA_ART,
  something_else: SOMETHING_ELSE,
}
